import { getAdditionalFields } from "./getAdditionalFields";
import { getAvailability } from "./getAvailability";
import { getCities } from "./getCities";
import { getCommission } from "./getCommission";
import { getGender } from "./getGender";
import { getMaritalStatus } from "./getMaritalStatus";
import { getOccupations } from "./getOccupations";
import { getOffersProposal } from "./getOffersProposal";
import { getRelationshipDegree } from "./getRelationshipDegree";
import { makeProposal } from "./makeProposal";
import { selectOffer } from "./selectOffer";

export const crefazService = {
  getAvailability,
  makeProposal,
  getOccupations,
  getOffersProposal,
  selectOffer,
  getCommission,
  getGender,
  getMaritalStatus,
  getRelationshipDegree,
  getAdditionalFields,
  getCities,
};
